import React from 'react'
import WorkOrderDetail from '../components/presentations/WorkOrderDetail'
import Layout from '../layout'

const WorkOrderDetailContainer = () => {
  return (
    <Layout>
      <WorkOrderDetail />
    </Layout>
  )
}

export default WorkOrderDetailContainer
